<app-table-component (onPagination)="onPagination($event)"
                     (selectedItem)="openDialog($event)"
                     [props]="tableConfigAndProps"></app-table-component>